import React, { useId, useState } from 'react';
import { Row, Col, FieldsetControl, RadioControl } from '@si-armes/dsfr-react';
import { useFormContext } from 'react-hook-form';
import InputFiles from 'components/Commun/Form/InputFiles';

const QuestionsPsychiatriques = () => {
    const { register, formState } = useFormContext();
    const [suiviTraitementPsychiatrique, setSuiviTraitementPsychiatrique] = useState(undefined);

    return (
        <>
            {/* Question sur les antécédents psychiatriques */}
            <Row gutters className="margin-top-sm">
                <Col lg={12}>
                    <FieldsetControl
                        id="suiviTraitementPsychiatrique"
                        legend="Avez-vous déjà suivi un traitement dans un hôpital psychiatrique ? *"
                        state={formState.errors?.suiviTraitementPsychiatrique ? 'error' : null}
                        message={formState.errors?.suiviTraitementPsychiatrique?.message}
                        inline
                    >
                        <RadioControl
                            className="margin-right-sm"
                            id={useId()}
                            {...register('suiviTraitementPsychiatrique', {
                                required: 'Ce champ est obligatoire',
                            })}
                            label="Non"
                            value={false}
                            onClick={() => setSuiviTraitementPsychiatrique(false)}
                        />
                        <RadioControl
                            className="margin-right-sm"
                            id={useId()}
                            {...register('suiviTraitementPsychiatrique')}
                            label="Oui"
                            value
                            onClick={() => setSuiviTraitementPsychiatrique(true)}
                        />
                    </FieldsetControl>
                </Col>
            </Row>

            {/* Certificat médical (conditionnel) */}
            {suiviTraitementPsychiatrique === true && (
                <Row gutters>
                    <Col lg={12}>
                        <InputFiles
                            label="Certificat médical (médecin psychiatre)"
                            {...register('pieceJointes.certificatMedicalPsychiatrique.fichiers', {
                                required: 'Ce champ est obligatoire',
                            })}
                            error={
                                formState.errors
                                    ? formState.errors?.pieceJointes?.certificatMedicalPsychiatrique
                                          ?.fichiers
                                    : null
                            }
                        />
                        <span>
                            Veuillez importer un certificat médical délivré par un médecin
                            psychiatrique
                        </span>
                    </Col>
                </Row>
            )}

            {suiviTraitementPsychiatrique === false && (
                <Row gutters>
                    <Col lg={12}>
                        <InputFiles
                            label="Certificat médical (moins d'un mois)"
                            {...register('pieceJointes.certificatMedicalPsychiatrique.fichiers')}
                            error={
                                formState.errors
                                    ? formState.errors?.pieceJointes?.certificatMedicalPsychiatrique
                                          ?.fichiers
                                    : null
                            }
                        />
                        <span>
                            Veuillez importer un certificat médical de moins d'un mois, délivré
                            selon les conditions prévues à l'article R.312-6, si déja suivi en
                            psychiatrie
                        </span>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default QuestionsPsychiatriques;
